import React, { useState } from 'react';
import AllLeadsGreen from './AllLeadsGreen';
import NewLeadsGreen from './NewLeadsGreen';
import PublishedLeadsGreen from './PublishedLeadsGreen';
import CancelLeads from './CancelLeads';
import { Link } from 'react-router-dom';

const LeadsGreen = () => {
  const [activeTab, setActiveTab] = useState(1); // State to track active tab

  // Function to handle tab change
  const handleTabChange = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  return (
    <div className="bg-white h-screen p-4">
      {/* Tab Buttons */}
      
      <div className="flex justify-between space-x-4 mb-4 w-full bg-green-500 my-2 rounded py-4 px-4">
          <div className='flex gap-5'>
          <button
          className={`py-2 px-6 font-montserrat text-lg text500 rounded ${activeTab === 1 ? 'bg-green-900 text-white' : 'bg-gray-50'}`}
          onClick={() => handleTabChange(1)}
        >
          All Leads
        </button>
        <button
          className={`py-2 px-6 font-montserrat text-lg text500 rounded ${activeTab === 2 ? 'bg-green-900 text-white' : 'bg-gray-50'}`}
          onClick={() => handleTabChange(2)}
        >
          New Leads
        </button>
        <button
          className={`py-2 px-6 font-montserrat text-lg text500 rounded ${activeTab === 3 ? 'bg-green-900 text-white' : 'bg-gray-50'}`}
          onClick={() => handleTabChange(3)}
        >
          Published Leads
        </button>
        <button
          className={`py-2 px-6 font-montserrat text-lg text500 rounded ${activeTab === 4 ? 'bg-green-900 text-white' : 'bg-gray-50'}`}
          onClick={() => handleTabChange(4)}
        >
          Cancel Leads
        </button>
          </div>
          {/* <Link to="/dashboardTwo/AdminAddLeads">
                <button className="px-8 py-4 shadow-sm text-lg font-montserrat text-white bg-green-700 rounded-md hover:bg-green-800 duration-300">
                  Add Leads
                 </button>
              </Link> */}
              <Link to="/dashboardTwo/AdminAddLeads">
               <button
          className={`py-2 px-6 font-montserrat text-lg hover:bg-green-900 hover:text-white duration-300 text500 rounded ${activeTab === 10 ? 'bg-green-900 text-white' : 'bg-gray-50'}`}
          onClick={() => handleTabChange(1)}
        >
          Add Leads
        </button>
        </Link>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 1 && 
        <AllLeadsGreen></AllLeadsGreen>
        }
        {activeTab === 2 && 
        <NewLeadsGreen></NewLeadsGreen>
        }
        {activeTab === 3 && 
        <PublishedLeadsGreen></PublishedLeadsGreen>
        }
        {activeTab === 4 && 
        <CancelLeads></CancelLeads>
        }
      </div>
    </div>
  );
};

export default LeadsGreen;
